// Reusable info tooltip — uses .info-tip CSS classes (defined in index.css)
export default function InfoTip({ children }) {
  return (
    <span className="info-tip" tabIndex={0} role="tooltip" data-testid="info-tip">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
      <span className="info-tip-content">{children}</span>
    </span>
  );
}
